import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";

import Page from "@/components/Page";
import Loading from "@/components/Loading";
import Breadcrumbs from "@/components/Breadcrumbs";
import MainActions from "@/components/MainActions";
import CardsContainer from "@/components/CardsContainer";
import CardsList from "@/components/CardsList";
import CardsTable from "@/components/CardsTable";

import {StaffRoleAPI} from "@/api/staff_role";

import AddIcon from "@mui/icons-material/Add";

import {ERROR_OPERATION} from "@/utils/constants";

import "./index.scss";

function StaffRolesPage(props) {
	const {handleNotification} = props;
	const navigate = useNavigate();

	const [loading, setLoading] = useState(false);
	const [staffRoles, setStaffRoles] = useState([]);

	const getRoles = async () => {
		try {
			const response = await StaffRoleAPI.list();
			setStaffRoles(response);
		} catch (error) {
			handleNotification(ERROR_OPERATION, "error");
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		getRoles();
	}, []);

	const listConfiguration = {
		data: staffRoles,
		onClick: (role) => navigate("/settings/staff-roles/" + role.id),
		title: (role) => role.name,
	};

	const columns = [{label: "Nome", key: "name", align: "start"}];

	const mainActions = [
		{
			icon: <AddIcon />,
			onClick: () => navigate("/settings/staff-roles/new"),
			color: "info",
		},
	];

	return (
		<Page>
			<Loading visible={loading} />
			<Breadcrumbs actions={<MainActions actions={mainActions} />} />
			<CardsContainer
				tableComponent={
					<CardsTable
						breadcrumbs
						configurationColumns={columns}
						data={staffRoles}
						fullWidth
						handleClick={(item) => {
							navigate("/settings/staff-roles/" + item.id);
						}}
						defaultSortedField="name"
					/>
				}
				listComponent={
					<CardsList
						type="users"
						breadcrumbs
						listConfiguration={listConfiguration}
						defaultSortedField="name"
					/>
				}
			/>
		</Page>
	);
}

export default StaffRolesPage;
